/**
 * True once a real CMP SDK (OneTrust or Ketch) is present on the page.
 *
 * While a CMP SDK is loaded, consent can still resolve — an explicit-consent banner may simply
 * be awaiting user interaction — so CMP-failure fallbacks must not fire. The real Ketch SDK
 * replaces the inline stub with an object exposing `loaded`; the inert stub never sets it.
 *
 * Shared by `loadTealiumClient` (Tealium injection watchdog) and `useConsentTracking`
 * (CONSENT_UPDATED failure fallback) so the two cannot disagree about whether the CMP failed.
 */
export const isCmpSdkLoaded = (): boolean => {
    const oneTrustLoaded = Boolean(window.OneTrust ?? window.OnetrustActiveGroups);
    const ketchLoaded = window.semaphore?.loaded === true;
    return oneTrustLoaded || ketchLoaded;
};
